class Area{
    constructor(id,name,extra){
        this.id=id;
        this.name=name;
        this.extra=extra;
    }
}

export default Area;